/* eslint-disable radix */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-expressions */

import { useEffect, useState, KeyboardEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import { useSales } from '../Sales/useSales'
import axios from 'axios'
import { getHistoricoBaixa } from '../../services/HistoricoBaixaService/getHistoricoBaixa'
import { getUsuariosTenantFiltro } from '../../services/Users/getUsers'

export const useHistoricoBaixa = () => {
  const { vendedores, clients, companies, produto } = useSales()
  const arrayClientes = Array.isArray(clients)
  const arrayVendedores = Array.isArray(vendedores)
  const arrayEmpresas = Array.isArray(companies)
  const arrayProdutos = Array.isArray(produto)

  const XTENANTID = localStorage.getItem('X-TENANT-ID')
  const tenantId = XTENANTID != null ? XTENANTID.slice(1, -1) : ' '
  const [usuarios, setUsuarios] = useState<UsuarioFiltroType[]>([])
  const arrayUsuarios = Array.isArray(usuarios)

  const [historicoDeBaixa, setHistoricoDeBaixa] =
    useState<GetHistoricoBaixaType>({} as GetHistoricoBaixaType)
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)

  const navigate = useNavigate()
  const goToPage = (id: number) => {
    navigate(`/historico-baixa/${id}`)
  }

  const startDate = dayjs()
  const dataHoje = startDate.format('DD/MM/YYYY')
  const lastDayOfMonth = dayjs().endOf('month')
  const dataFim = lastDayOfMonth.format('DD/MM/YYYY')
  const [calendarFim, setCalendarFim] = useState(dataFim)
  const [calendarInicio, setCalendarInicio] = useState(dataHoje)

  const [client, setClient] = useState<number[]>([])

  const [salesPeople, setSalesPeople] = useState<number[]>([])
  const [valueCompanieId, setValueCompanieId] = useState<number[]>([])
  const [valueProductId, setValueProductId] = useState<number[]>([])
  const [usuarioEmail, setUsuarioEmail] = useState<string[]>([])
  const [statusChecked, setStatusChecked] = useState<string[]>([])
  const [statusCheckedTodos, setStatusCheckedTodos] = useState<string[]>([])
  const [statusCheckedFiltro, setStatusCheckedFiltro] = useState<string[]>([])

  const [valueClient, setValueClient] = useState<string[]>([])
  const [valueSalesPeople, setValueSalesPeople] = useState<string[]>([])
  const [valueCompanie, setValueCompanie] = useState<string[]>([])
  const [valueProduct, setValueProduct] = useState<string[]>([])
  const [valueUsuario, setValueUsuario] = useState<string[]>([])

  const valueClientString = valueClient.map(id => {
    const clientName = clients.find(name => name.nome === id)
    return clientName ? clientName.id : undefined
  })
  const clientArray = valueClientString.filter(
    value => value !== undefined
  ) as number[]

  const valueSalesPeopleString = valueSalesPeople.map(id => {
    const salesPeopleName = vendedores.find(name => name.nome === id)
    return salesPeopleName ? salesPeopleName.id : undefined
  })
  const salesPeopleArray = valueSalesPeopleString.filter(
    value => value !== undefined
  ) as number[]

  const valueCompanieString = valueCompanie.map(id => {
    const companieName = companies.find(name => name.nome === id)
    return companieName ? companieName.id : undefined
  })
  const companieArray = valueCompanieString.filter(
    value => value !== undefined
  ) as number[]

  const valueProductString = valueProduct.map(id => {
    const productName = produto.find(name => name.nome === id)
    return productName ? productName.id : undefined
  })
  const productArray = valueProductString.filter(
    value => value !== undefined
  ) as number[]

  const valueUsuarioString = valueUsuario.map(nome => {
    const usuarioEncontrado = usuarios.find(item => item.nome === nome)
    return usuarioEncontrado ? usuarioEncontrado.email : undefined
  })
  const usuarioEmailArray = valueUsuarioString.filter(
    value => value !== undefined
  ) as string[]

  const [selectedOptionsClient, setSelectedOptionsClient] = useState<string[]>(
    []
  )
  const [selectedOptionsSalesPeople, setSelectedOptionsSalesPeople] = useState<
    string[]
  >([])
  const [selectedOptionsProdutos, setSelectedOptionsProdutos] = useState<
    string[]
  >([])
  const [selectedOptionsEmpresas, setSelectedOptionsEmpresas] = useState<
    string[]
  >([])
  const [selectedOptionsUsuario, setSelectedOptionsUsuario] = useState<
    string[]
  >([])

  const fetchUsuarios = async () => {
    const result = await getUsuariosTenantFiltro(tenantId)
    setUsuarios(result)
  }

  const fetchClient = async (cancel?: any) => {
    setIsLoading(true)

    const result = await getHistoricoBaixa(
      cancel,
      client,
      salesPeople,
      valueProductId,
      valueCompanieId,
      statusCheckedFiltro,
      calendarFim,
      calendarInicio,
      currentPage,
      usuarioEmail
    )
    setIsLoading(false)

    if ('message' in result) {
      if (result.message === 'cancelToken') {
        ;('')
      } else {
        toast.error(result.message)
      }
    } else {
      setHistoricoDeBaixa(result)
    }
  }

  const handleFiltroCliente = (event: string[]) => {
    localStorage.setItem('filtroClienteHistoricoBaixa', JSON.stringify(event))
    setValueClient(event)
  }

  const handleFiltroVendedor = (event: string[]) => {
    localStorage.setItem('filtroVendedorHistoricoBaixa', JSON.stringify(event))
    setValueSalesPeople(event)
  }

  const handleFiltroEmpresa = (event: string[]) => {
    localStorage.setItem('filtroEmpresaHistoricoBaixa', JSON.stringify(event))
    setValueCompanie(event)
  }

  const handleFiltroProduto = (event: string[]) => {
    localStorage.setItem('filtroProdutoHistoricoBaixa', JSON.stringify(event))
    setValueProduct(event)
  }

  const handleClienteFiltrado = (event: number[]) => {
    localStorage.setItem('clienteFiltradoHistoricoBaixa', JSON.stringify(event))
    setClient(event)
  }

  const handleVendedorFiltrado = (event: number[]) => {
    localStorage.setItem(
      'vendedorFiltradoHistoricoBaixa',
      JSON.stringify(event)
    )
    setSalesPeople(event)
  }

  const handleEmpresaFiltrada = (event: number[]) => {
    localStorage.setItem('empresaFiltradaHistoricoBaixa', JSON.stringify(event))
    setValueCompanieId(event)
  }

  const handleProdutoFiltrado = (event: number[]) => {
    localStorage.setItem('produtoFiltradoHistoricoBaixa', JSON.stringify(event))
    setValueProductId(event)
  }

  const handleFiltroUsuario = (event: string[]) => {
    localStorage.setItem('filtroUsuarioHistoricoBaixa', JSON.stringify(event))
    setValueUsuario(event)
  }

  const handleUsuarioFiltrado = (event: string[]) => {
    localStorage.setItem('usuarioFiltradoHistoricoBaixa', JSON.stringify(event))
    setUsuarioEmail(event)
  }

  const handleCheckboxChange = (option: string) => {
    if (option === 'TODOS') {
      if (statusChecked.includes('TODOS')) {
        setStatusChecked([])
      } else {
        setStatusChecked([])
        setStatusCheckedTodos([])

        localStorage.setItem('filtroStatusHistoricoBaixa', JSON.stringify([]))
      }
    } else if (statusChecked.includes('TODOS')) {
      setStatusChecked([option])
    } else if (statusChecked.includes(option)) {
      setStatusChecked(statusChecked.filter(item => item !== option))

      statusChecked.length === 1
        ? setStatusCheckedTodos([])
        : setStatusCheckedTodos(['TODOS'])

      localStorage.setItem(
        'filtroStatus',
        JSON.stringify(statusChecked.filter(item => item !== option))
      )
    } else {
      setStatusChecked([...statusChecked, option])
      setStatusCheckedTodos(['TODOS'])
      localStorage.setItem(
        'filtroStatus',
        JSON.stringify([...statusChecked, option])
      )
    }
  }

  const handleLimparFiltros = () => {
    localStorage.setItem('dataInicioHistoricoBaixa', JSON.stringify(dataHoje))
    localStorage.removeItem('filtroStatusHistoricoBaixa')
    localStorage.removeItem('filtroClienteHistoricoBaixa')
    localStorage.removeItem('filtroVendedorHistoricoBaixa')
    localStorage.removeItem('filtroEmpresaHistoricoBaixa')
    localStorage.removeItem('filtroProdutoHistoricoBaixa')
    localStorage.removeItem('clienteFiltradoHistoricoBaixa')
    localStorage.removeItem('vendedorFiltradoHistoricoBaixa')
    localStorage.removeItem('empresaFiltradaHistoricoBaixa')
    localStorage.removeItem('produtoFiltradoHistoricoBaixa')
    localStorage.removeItem('filtroUsuarioHistoricoBaixa')
    localStorage.removeItem('usuarioFiltradoHistoricoBaixa')
    window.location.reload()
  }

  const [showClient, setShowClient] = useState(false)
  const [showSalesPeople, setShowSalesPeople] = useState(false)
  const [showCompanies, setShowCompanies] = useState(false)
  const [showStatus, setShowStatus] = useState(false)
  const [showProducts, setShowProducts] = useState(false)
  const [showUsuario, setShowUsuario] = useState(false)

  const handleShowFilterClient = () => {
    setShowClient(!showClient)
    showSalesPeople ? setShowSalesPeople(!showSalesPeople) : ''
    showCompanies ? setShowCompanies(!showCompanies) : ''
    showStatus ? setShowStatus(!showStatus) : ''
    showProducts ? setShowProducts(!showProducts) : ''
    showUsuario ? setShowUsuario(!showUsuario) : ''
  }

  const handleShowFilterSalesPeople = () => {
    showClient ? setShowClient(!showClient) : ''
    setShowSalesPeople(!showSalesPeople)
    showCompanies ? setShowCompanies(!showCompanies) : ''
    showStatus ? setShowStatus(!showStatus) : ''
    showProducts ? setShowProducts(!showProducts) : ''
    showUsuario ? setShowUsuario(!showUsuario) : ''
  }
  const handleShowFilterCompanie = () => {
    showClient ? setShowClient(!showClient) : ''
    setShowCompanies(!showCompanies)
    showSalesPeople ? setShowSalesPeople(!showSalesPeople) : ''
    showStatus ? setShowStatus(!showStatus) : ''
    showProducts ? setShowProducts(!showProducts) : ''
    showUsuario ? setShowUsuario(!showUsuario) : ''
  }
  const handleShowStatus = () => {
    showClient ? setShowClient(!showClient) : ''
    setShowStatus(!showStatus)
    showSalesPeople ? setShowSalesPeople(!showSalesPeople) : ''
    showCompanies ? setShowCompanies(!showCompanies) : ''
    showProducts ? setShowProducts(!showProducts) : ''
    showUsuario ? setShowUsuario(!showUsuario) : ''
  }
  const handleShowProduto = () => {
    showClient ? setShowClient(!showClient) : ''
    setShowProducts(!showProducts)
    showSalesPeople ? setShowSalesPeople(!showSalesPeople) : ''
    showCompanies ? setShowCompanies(!showCompanies) : ''
    showStatus ? setShowStatus(!showStatus) : ''
    showUsuario ? setShowUsuario(!showUsuario) : ''
  }
  const handleShowUsuario = () => {
    showClient ? setShowClient(!showClient) : ''
    setShowUsuario(!showUsuario)
    showSalesPeople ? setShowSalesPeople(!showSalesPeople) : ''
    showCompanies ? setShowCompanies(!showCompanies) : ''
    showStatus ? setShowStatus(!showStatus) : ''
    showProducts ? setShowProducts(!showProducts) : ''
  }

  const handleKeyClosed = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      showClient ? setShowClient(!showClient) : ''
      showSalesPeople ? setShowSalesPeople(!showSalesPeople) : ''
      showProducts ? setShowProducts(!showProducts) : ''
      showStatus ? setShowStatus(!showStatus) : ''
      showCompanies ? setShowCompanies(!showCompanies) : ''
      showUsuario ? setShowUsuario(!showUsuario) : ''
    }
  }

  useEffect(() => {
    fetchUsuarios()
  }, [])

  useEffect(() => {
    const filtroCliente = localStorage.getItem('filtroClienteHistoricoBaixa')
    const filtroVendedor = localStorage.getItem('filtroVendedorHistoricoBaixa')
    const filtroStatus = localStorage.getItem('filtroStatusHistoricoBaixa')
    const filtroEmpresa = localStorage.getItem('filtroEmpresaHistoricoBaixa')
    const filtroProduto = localStorage.getItem('filtroProdutoHistoricoBaixa')
    const filtroUsuario = localStorage.getItem('filtroUsuarioHistoricoBaixa')

    const dataFiltrada = localStorage.getItem('dataInicioHistoricoBaixa')
    const clienteFiltradoLocalStorage = localStorage.getItem(
      'clienteFiltradoHistoricoBaixa'
    )
    const vendedorFiltradoLocalStorage = localStorage.getItem(
      'vendedorFiltradoHistoricoBaixa'
    )
    const empresaFiltradaLocalStorage = localStorage.getItem(
      'empresaFiltradaHistoricoBaixa'
    )
    const produtoFiltrdoLocalStorage = localStorage.getItem(
      'produtoFiltradoHistoricoBaixa'
    )
    const usuarioFiltradoLocalStorage = localStorage.getItem(
      'usuarioFiltradoHistoricoBaixa'
    )

    if (dataFiltrada) {
      setCalendarInicio(JSON.parse(dataFiltrada))
    }

    if (filtroCliente) {
      setValueClient(JSON.parse(filtroCliente))
    }

    if (filtroVendedor) {
      setValueSalesPeople(JSON.parse(filtroVendedor))
    }

    if (filtroStatus) {
      setStatusChecked(JSON.parse(filtroStatus))
      setStatusCheckedFiltro(JSON.parse(filtroStatus))
      filtroStatus.length === 2
        ? setStatusCheckedTodos([])
        : setStatusCheckedTodos(['TODOS'])
    }

    if (filtroEmpresa) {
      setValueCompanie(JSON.parse(filtroEmpresa))
    }

    if (filtroProduto) {
      setValueProduct(JSON.parse(filtroProduto))
    }

    if (filtroUsuario) {
      setValueUsuario(JSON.parse(filtroUsuario))
    }

    if (clienteFiltradoLocalStorage) {
      const cliente = JSON.parse(clienteFiltradoLocalStorage).map(
        (id: string) => parseInt(id)
      )
      setClient(cliente)
    }
    if (vendedorFiltradoLocalStorage) {
      const vendedor = JSON.parse(vendedorFiltradoLocalStorage).map(
        (id: string) => parseInt(id)
      )
      setSalesPeople(vendedor)
    }
    if (empresaFiltradaLocalStorage) {
      const empresa = JSON.parse(empresaFiltradaLocalStorage).map(
        (id: string) => parseInt(id)
      )
      setValueCompanieId(empresa)
    }
    if (produtoFiltrdoLocalStorage) {
      const produtos = JSON.parse(produtoFiltrdoLocalStorage).map(
        (id: string) => parseInt(id)
      )
      setValueProductId(produtos)
    }
    if (usuarioFiltradoLocalStorage) {
      setUsuarioEmail(JSON.parse(usuarioFiltradoLocalStorage))
    }
  }, [])

  useEffect(() => {
    setSelectedOptionsClient(valueClient)
    setSelectedOptionsSalesPeople(valueSalesPeople)
    setSelectedOptionsEmpresas(valueCompanie)
    setSelectedOptionsProdutos(valueProduct)
    setSelectedOptionsUsuario(valueUsuario)
  }, [valueClient, valueSalesPeople, valueCompanie, valueProduct, valueUsuario])

  useEffect(() => {
    const source = axios.CancelToken.source()
    fetchClient(source)
    return () => {
      source.cancel('cancelToken')
    }
  }, [
    JSON.stringify({
      currentPage,
      calendarFim,
      calendarInicio,
      client,
      salesPeople,
      valueCompanieId,
      valueProductId,
      statusCheckedFiltro,
      usuarioEmail,
    }),
  ])

  return {
    setClient,
    setSalesPeople,
    setCalendarInicio,
    setCalendarFim,
    historicoDeBaixa,
    isLoading,
    fetchClient,
    goToPage,
    setCurrentPage,
    currentPage,
    handleShowFilterClient,
    handleShowFilterSalesPeople,
    showClient,
    showSalesPeople,
    handleKeyClosed,

    setSelectedOptionsClient,
    selectedOptionsSalesPeople,
    selectedOptionsClient,
    setSelectedOptionsSalesPeople,

    selectedOptionsProdutos,
    setSelectedOptionsProdutos,
    selectedOptionsEmpresas,
    setSelectedOptionsEmpresas,
    selectedOptionsUsuario,
    setSelectedOptionsUsuario,

    dataHoje,

    handleShowFilterCompanie,
    showCompanies,

    setValueCompanieId,
    showStatus,
    handleShowStatus,

    showProducts,
    setValueProductId,
    handleShowProduto,

    showUsuario,
    handleShowUsuario,
    setUsuarioEmail,

    handleCheckboxChange,
    statusChecked,
    setStatusChecked,
    statusCheckedTodos,
    setStatusCheckedTodos,
    setStatusCheckedFiltro,
    statusCheckedFiltro,

    valueClient,
    setValueClient,
    valueSalesPeople,
    setValueSalesPeople,
    valueCompanie,
    setValueCompanie,
    valueProduct,
    setValueProduct,
    valueUsuario,
    setValueUsuario,

    arrayClientes,
    arrayVendedores,
    arrayEmpresas,
    arrayProdutos,
    arrayUsuarios,

    productArray,
    companieArray,
    salesPeopleArray,
    clientArray,
    usuarioEmailArray,

    vendedores,
    clients,
    companies,
    produto,
    usuarios,

    handleFiltroCliente,
    handleFiltroVendedor,
    handleFiltroEmpresa,
    handleFiltroProduto,
    handleFiltroUsuario,
    handleLimparFiltros,

    handleClienteFiltrado,
    handleVendedorFiltrado,
    handleEmpresaFiltrada,
    handleProdutoFiltrado,
    handleUsuarioFiltrado,

    startDate,
  }
}
